


import { Component, Mixins } from 'vue-property-decorator';
import UserRightsMixin from '~/mixins/UserRightsMixin';
import { RemoteFeatureFlagsModule } from '~/store/modules/remoteFeatureFlags';

@Component({
    components: {
        RemoteFeatureFlagsList: () => import('~/components/RemoteFeatureFlags/Flags/List.vue'),
        RemoteFeatureFlagsCreator: () => import('~/components/RemoteFeatureFlags/Flags/Creator.vue'),
        GroupsList: () => import('~/components/RemoteFeatureFlags/Groups/List.vue'),
        GroupsCreator: () => import('~/components/RemoteFeatureFlags/Groups/Creator.vue')
    }
})
export default class RemoteFeatureFlags extends Mixins(UserRightsMixin) {
    tab = 0;

    async created() {
        await RemoteFeatureFlagsModule.getAvailableFlags();
        await RemoteFeatureFlagsModule.getAvailableGroups();
    }
}

